module.exports = __webpack_public_path__ + "edd377b5e2284fe33cbc156811083380.gif";